import axios from "axios";

export default {
    namespaced: true,

    state: {
        mapAttributes: [],
    },

    getters: {
        mapAttributes(state) {
            return state.mapAttributes;
        },
    },

    mutations: {
        SET_MAP_ATTRIBUTES(state, mapAttributes) {
            state.mapAttributes = mapAttributes;
        },
    },

    actions: {
        async getMapAttributes({ commit }, id) {
            return await axios.get("/api/get-all-map-attributes", {
                params: { id },
            });
        },
        async saveMapAttribute({ commit }, payload) {
            await axios
                .post("/api/create-map-attribute", payload)
                .then((response) => {});
        },
        async getAttribute({ commit }, id) {
            return await axios.get("/api/get-map-attribute", {
                params: { id },
            });
        },
        async updateMapAttribute({ commit }, payload) {
            await axios
                .post("/api/update-map-attribute", payload)
                .then((response) => {});
        },
        async deleteMapAttribute({ commit }, id) {
            await axios
                .post("/api/delete-map-attribute", { id })
                .then((response) => {});
        },
        // async updateData({ dispatch }) {
        //     await dispatch("getAllMapsGroups");
        // },
    },
};
